import React, { useState, useEffect } from "react";
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount, useSignMessage, useFeeData, erc20ABI, useContractWrite, useBalance } from 'wagmi'
import { watchBlockNumber, watchAccount } from 'wagmi/actions'
import { Space, Button, InputNumber, Modal, message, Spin } from "antd";
import { alertInfo, alertOk, alertError, notiError } from "./utils/antd-helper";
import broadcast from "./utils/broadcast";
import api from "./controls/api";
import copy from "copy-to-clipboard";
import store from './utils/store';
import * as formatter from './utils/formatter';
import webconfig from './webconfig';

let broadcastSender = console.log;
let isCheckRule = false;
let inviteCode = "";
let uinfo = null;
let lastAddr = "";

const App = () => {
  const account = useAccount();
  const { signMessageAsync } = useSignMessage();
  const [price, setPrice] = useState(0);
  const [toAddress, setToAddress] = useState();
  const [buyCount, setBuyCount] = useState("");

  const [invitCode, setInvitCode] = useState("");
  const [vipcode, setVipcode] = useState("");
  const [showVipcode, setShowVipcode] = useState(false);

  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasLogin, setHasLogin] = useState(false);
  const [winWidth, setWinWidth] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalWidth, setMmodalWidth] = useState(1213);
  const [modalTitle, setMmodalTitle] = useState();

  const [purchaseList, setPurchaseList] = useState([]);
  const [purchaseMyPoints, setPurchaseMyPoints] = useState(0);

  const [invitedList, setInvitedList] = useState([]);
  const [rewards, setRewards] = useState(0);

  const [noticeOpen, setNoticeOpen] = useState(1);

  const usdtBalance = useBalance({
    address: account.address,
    token: webconfig.contractAddress,
  });
  const ethBalance = useBalance({
    address: account.address
  });
  const gasPriceResult = useFeeData({ chainId: webconfig.chain.id });

  const { writeAsync } = useContractWrite({
    address: webconfig.contractAddress,
    abi: erc20ABI,
    chainId: webconfig.chain.id,
    functionName: 'transfer'
  });

  const showModal = async (title, maxWidth) => {
    if (!account.address && title == "Purchase record") {
      return alertError("Please connect the wallet.");
    }
    if (!maxWidth) {
      maxWidth = winWidth * 0.9;
    }
    let w = winWidth * 0.9;
    if (w > maxWidth) {
      w = maxWidth;
    }
    if (w == 0) {
      w = 700;
    }
    setMmodalWidth(w);
    setIsModalOpen(true);
    setMmodalTitle(title);
    if (title == "Purchase record") {
      setLoading(true);
      let ret = await api.getTransactionList(account.address);
      if (ret.msg != 'ok') {
        setLoading(false);
        return alertError(ret.msg);
      }
      if (ret.data) {
        let points = 0;
        ret.data.forEach(t => {
          t.hash = formatter.formatAddress(t.txhash);
          points += t.point;
        });
        setPurchaseMyPoints(points);
        setPurchaseList(ret.data);
      }
      setLoading(false);
    } else if (title == "Invited History") {
      setLoading(true);
      let ret = await api.getInvitationList(account.address);
      if (ret.msg != 'ok') {
        setLoading(false);
        return alertError(ret.msg);
      }
      if (ret.data) {
        let reward = 0;
        ret.data.forEach(t => {
          t.accountStr = formatter.formatAddressLong(t.account);
          reward += parseInt(t.reward);
        });
        setRewards(reward);
        setInvitedList(ret.data);
      }
      setLoading(false);
    }
  }
  const setWindowWidth = () => {
    let w = document.body.clientWidth;
    setWinWidth(w);
    broadcastSender(document.body.clientHeight + 150);
  }

  //click event 
  const onCopy = (text) => {
    copy(text);
    message.success("Copy successful !");
  }
  const onInputInviteCode = (e) => {
    inviteCode = e.target.value;
    setInvitCode(inviteCode);
  }
  const onInputBuyCount = (e) => {
    let n = e.target.value;
    if (!n) {
      return setBuyCount("");
    }
    n = parseInt(n);
    if (n < 1) {
      n = 1;
    } else if (n > 5) {
      n = 5;
    }
    setBuyCount(n);
  }
  const onInputVipCode = (e) => {
    let n = e.target.value;
    setVipcode(n);
  }
  const onChangeCheck = (e) => {
    isCheckRule = !isCheckRule;
    console.log({ isCheckRule })
  }
  const onLogin = async () => {
    try {
      if (!account || !account.address) {
        return document.querySelector(".iekbcc9").click();
      }
      setLoading(true);
      let addr = account.address;
      if (!addr) {
        return alertError('Please connect wallet.');
      }
      let ret = await api.getRandomMsg(addr);
      if (ret.msg != 'ok') {
        return alertError(ret.msg);
      }
      ret = await signMessageAsync({ message: ret.data });
      if (!ret) {
        return;
      }
      ret = await api.login(addr, ret);
      if (ret.msg != 'ok') {
        return alertError(ret.msg);
      }
      let info = ret.data.account;
      setUserInfo(info);
      message.success("Login successful !");
      setLoading(false);
      setHasLogin(true);
      if (!info.beInvitedBy) {
        let icode = store.get("invcode");
        if (icode && typeof icode == 'string') {
          inviteCode = icode;
          setInvitCode(inviteCode);
        }
        showModal("Got an invite code?", 700);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }
  const onBuy = async () => {
    let addr = account.address;
    // console.log({result});return;
    if (!addr) {
      return alertError('Please connect wallet.');
    }
    if (!buyCount || buyCount < 1 || buyCount > 5) {
      return alertError('The amount must be between 1 and 5.');
    }
    if (!isCheckRule) {
      return alertError('Please read and agree that Genesis Nodes are not an investments.');
    }
    if (!toAddress) {
      return alertError('Network error.');
    }
    if (!hasLogin) {
      return onLogin();
    }
    onBuySubmit();
    // showModal("Please confirm the receiving address", 700);
  }
  const onGetUserInfo = async (address) => {
    let ret = await api.login(address);
    ret = await api.getUserInfo(address);
    if (ret.msg == 'ok' && ret.data) {
      uinfo = ret.data;
      uinfo.points = uinfo.points.toString();
      setUserInfo(uinfo);
      setHasLogin(true);
      if (!uinfo.beInvitedBy) {
        let icode = store.get("invcode");
        if (icode && typeof icode == 'string') {
          inviteCode = icode;
          setInvitCode(inviteCode);
        }
        showModal("Got an invite code?", 700);
      }
    }
  }
  const onBuySubmit = async () => {
    try {
      let amount = parseInt(price * buyCount);
      console.log({ amount });
      let gas = gasPriceResult.data.gasPrice;
      if (ethBalance.data.value < gas) {
        return alertError('Insufficient funds for gas price.');
      }
      if (usdtBalance.data.value < amount) {
        return alertError('Insufficient balance.');
      }
      // console.log(gasPriceResult);
      // console.log(usdtBalance.data.value);
      // console.log(ethBalance.data.value);
      // return;
      setLoading(true);
      setIsModalOpen(false);
      let ret = await writeAsync({
        address: webconfig.contractAddress,
        abi: erc20ABI,
        chainId: webconfig.chain.id,
        functionName: 'transfer',
        args: [toAddress, amount]
      });
      console.log(ret);
      let txhash = ret?.hash;
      if (!txhash) {
        setLoading(false);
        return notiError('Transaction canceled');
      }
      ret = await api.purchase(account.address, toAddress, amount.toString(), txhash);
      if (ret.msg != 'ok') {
        setLoading(false);
        return alertError(ret.msg);
      }
      setLoading(false);
      message.success("Purchase has submit !");
    } catch (e) {
      setLoading(false);
      console.log('error ', e.message);
      if (e.message.toString().indexOf('transfer amount exceeds balance') != -1) {
        return alertError('Insufficient balance');
      }
      // alertError(e.message);
    }
  }
  const onSkipInviteCode = async () => {
    inviteCode = '--'
    setLoading(true);
    let ret = await api.submitInviteCode(account.address, inviteCode);
    store.remove('invcode');
    setInvitCode("");
    setLoading(false);
    setIsModalOpen(false);
  }
  const onSetInviteCode = async () => {
    if (!inviteCode) {
      return alertError('Please input a invite code.');
    }
    setLoading(true);
    let ret = await api.submitInviteCode(account.address, inviteCode);
    setLoading(false);
    if (ret.msg != 'ok') {
      setLoading(false);
      return alertError(ret.msg);
    }
    store.remove('invcode');
    setInvitCode("");
    message.success("Set invite code success.");
    setIsModalOpen(false);
  }
  const onCopyInvitationLink = () => {
    let url = window.location.origin + '/genesisnodes?code=' + userInfo?.code;
    onCopy(url);
  }
  const onSumbitVipcode = async () => {
    if (!vipcode) {
      return alertError('Please input a code.');
    }
    if (!account?.address) {
      return alertError('Please login.');
    }
    setLoading(true);
    let ret = await api.submitInviteCode(account.address, vipcode);
    console.log(ret);
    setLoading(false);
    if (ret.msg != 'ok') {
      setLoading(false);
      return alertError(ret.msg);
    }
    setVipcode("");
    message.success("Set code success.");
    ret = await api.getUserInfo(account.address);
    if (ret.msg == 'ok' && ret.data) {
      uinfo = ret.data;
      uinfo.points = uinfo.points.toString();
      setUserInfo(uinfo);
    }
    setShowVipcode(false);
  }
  function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
  }
  useEffect(() => {
    let tmp = store.get('user-info');
    if (tmp) {
      setUserInfo(tmp);
    }
    tmp = store.get('token');
    if (tmp) {
      setHasLogin(true);
    }
    api.getPrice().then(ret => {
      if (ret.msg == 'ok') {
        setToAddress(ret.data.address);
        setPrice(ret.data.price);
        // chainId = ret.data.chain;
      }
    }, console.log);
    broadcastSender = broadcast();
    setWindowWidth();
    window.onresize = function () {
      setWindowWidth();
    }
    let code = getQueryString('code');
    if (!code) {
      code = store.get('invcode');
    }
    if (code && typeof code == 'string') {
      console.log({ code })
      store.set('invcode', code);
      setInvitCode(code);
      inviteCode = code;
    }
  }, []);


  useEffect(() => {
    setInterval(function () {
      let e = document.querySelector("#myaddr");
      if (e) {
        let addr = e.getAttribute('data-addr');
        if (!uinfo || lastAddr != addr) {
          lastAddr = addr;
          store.set('addr', addr);
          onGetUserInfo(addr);
        }
      }
    }, 1000);
  }, [])

  return (
    <div>
      <a className="header" href="/"></a>
      <div className="duan1">
        <div className="box1">
          <div className="t1">Join CESS Mainnet as a Genesis Node</div>
          <div className="t2">CESS Mainnet Launching Soon <br />Number of Genesis Storage Nodes: <font>100</font></div>
        </div>
        <div className="box2">
          <Spin spinning={loading}>
            <div className="t2">
              <ConnectButton
                showBalance={false}
                accountStatus='avatar'
                chainStatus="none"
              />
              {
                !account || !account.address || !userInfo?.code ? "" : (<>
                  <span className="my-points link" onClick={() => showModal("Invited History", 1213)}>Invitation Records</span>
                  <span className="copy-btn com-btn" onClick={onCopyInvitationLink}>Copy the invitation link</span></>)
              }
            </div>
          </Spin>
        </div>
        <div className="box3">
          <Spin spinning={loading}>
            <div className="box-in">
              <div className="top-txt-box">
                <div className="nft-img"></div>
                <div className="txt-box">
                  <label>CESS Genesis Node</label>
                  <span>15,000 <font>USDT</font></span>
                </div>
              </div>
              <div className="form-box">
                <div className="v-line">
                  <span className="left">Amount</span>
                  <span className="right">
                    <input type="number" value={buyCount} className="myinput" onKeyUp={onInputBuyCount} onChange={onInputBuyCount} placeholder="Maximum 5" />

                  </span>
                </div>
                <div className="line">
                  <span className="left">Total</span>
                  <span className="right">
                    <label className="show-txt">{buyCount ? formatter.formatBalance(price * buyCount) : 0} USDT</label>
                  </span>
                </div>
                <div className="line">
                  <label>
                    <input type="checkbox" onChange={onChangeCheck} ></input>
                    <span style={{ fontSize: 16 }}>I read, understand and agree that the <a onClick={() => showModal("Disclaimer for CESS Genesis Nodes", 900)} className="a-link">Genesis Node is not an investment.</a></span>
                  </label>
                </div>
                <div className="btn-line">
                  {account?.address ? <span className="mybtn" onClick={onBuy}>Purchase</span> : <span className="mybtn" onClick={onLogin}>Connect Wallet</span>}
                  <span className="mybtn2" onClick={() => showModal("Purchase record", 1213)}>Purchase history</span>
                </div>
                {
                  account?.address && !userInfo?.code ? <div className="line">
                    <center className="center-tips" onClick={() => setShowVipcode(!showVipcode)}>Code {showVipcode ? '-' : '+'}</center>
                  </div> : ""
                }
                {
                  account?.address && showVipcode && !userInfo?.code ? (<div className="v-line">
                    <span className="flex">
                      <input type="text" value={vipcode} className="myinput" onKeyUp={onInputVipCode} onChange={onInputVipCode} placeholder="Please input the code" />
                      <span onClick={onSumbitVipcode}>Submit</span>
                    </span>
                  </div>) : ""
                }

                {/* <div className="line">
                <div className="tips2" onClick={() => showModal("Purchase record", 1213)}>
                  <div><label></label><span></span></div>
                  <font>Copy the Invitation Link</font>
                </div>
              </div> */}
              </div>
            </div>
          </Spin>
        </div>
      </div>
      <div className="duan2">
        <div className="box4">
          <h4>Important Notice </h4>
          <i onClick={()=>setNoticeOpen(1)} className={noticeOpen==1?'icon-open':'icon-close'}></i>
          <span className={noticeOpen==1?'open':'close'}>
            1. Your orders cannot be modified or cancelled after confirmation.
            <br /><br />
            2. After successful purchase, a transaction will be automatically initiated on-chain, and its timing will be affected by Arbitrum network congestion.
            <br /><br />
            3. When CESS mainnet launches, the payment address will receive a certain number of mainnet $CESS tokens as staked tokens for CESS Genesis Nodes.
          </span>
        </div>
        <div className="box5">
          <h4>How to participate in CESS Genesis Nodes</h4>
          <i onClick={()=>setNoticeOpen(2)} className={noticeOpen==2?'icon-open':'icon-close'}></i>
          <span className={noticeOpen==2?'open':'close'}>
            1. 100 Genesis Nodes are available on a first-come, first-served basis. <br /><br />
            2. Each wallet address is limited to purchasing 5 Genesis Nodes. <br /><br />
            3. Genesis Nodes are available for public sale at 15,000 USDT each. Each Genesis Node will receive N $CESS tokens for mainnet staking ("N" equals the staking amount needed for 60-80T, not yet determined for each T on the CESS mainnet). <br /><br />
            4. Exclusive benefits are allocated to early participants as follows: <br /><br />
            - The 1st to 20th Genesis Nodes will receive an additional 20% on top of the N $CESS tokens, 21st-40th receiving an additional 15%, with 41st-60th receiving an additional 10% , 61st-80th receiving an additional 5%, and 81st-100th receiving no bonus. <br /><br />
            5. Anyone can be the inviter to generate an invitation link; if the invitee successfully purchases a node, the inviter gets 15,000 $CESS. <br /><br />

            6. $CESS awarded to Genesis Nodes and invitation rewards will be distributed after the mainnet launch. <br /><br />
            7. CESS holds the final interpretative authority.
          </span>
        </div>
        <div className="box5">
          <h4>FAQs</h4>
          <i onClick={()=>setNoticeOpen(3)} className={noticeOpen==3?'icon-open':'icon-close'}></i>
          <span className={noticeOpen==3?'open':'close'}>
            1. What are CESS Genesis Storage Nodes?<br />
            Genesis Storage Nodes play a pivotal role in CESS Data Value Network as the earliest participants. These nodes provide essential storage space resources during the network's initial phase, ensuring CESS network's smooth operation. The contributions of Genesis Storage Nodes are crucial for the network's security and stability.
            <br /><br />
            2. Besides the granted mainnet $CESS, will Genesis Nodes receive other benefits?<br />
            Additional benefits may include whitelist privileges and airdrop opportunities.<br /><br />

            3. When can Genesis Nodes start earning rewards?<br />
            The distribution of rewards will commence following the launch of the mainnet, projected for 2024. Stay tuned for CESS announcements!
          </span>
        </div>
      </div>
      <Modal title={modalTitle} width={modalWidth} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
        <Spin spinning={loading}>
          <div className={modalTitle == "Purchase record" ? "purchase-record" : "none"}>
            {/* <div className="btn">My points: {purchaseMyPoints}</div> */}
            <div className="con-table">
              <div className="table">
                <div className="tb-header">
                  <span className="td td1">Events</span>
                  <span className="td td2">Transation Hash</span>
                  <span className="td td3">Quantity</span>
                  <span className="td td4">Amount</span>
                  <span className="td td6">Date(UTC-0)</span>
                  <span className="td td7">Stats</span>
                </div>
                <div className="tb-body">
                  {
                    purchaseList.map((item, i) => {
                      return (
                        <div className="tr" key={i}>
                          <span className="td td1">{item["event"]}</span>
                          <span className="td td2" onClick={() => onCopy(item.txhash)} title="copy">{item["hash"]}</span>
                          <span className="td td3">{item["quantity"]}</span>
                          <span className="td td4">{formatter.formatBalance(item["amount"])}</span>
                          <span className="td td6">{item["date"]}</span>
                          <span className="td td7"><label className={"status status-" + item["status"]}>{item["status"]}</label></span>
                        </div>
                      )
                    })
                  }
                </div>
                <div className={purchaseList.length > 0 ? "none" : "no-record"}>No record</div>
              </div>
            </div>
          </div>
          <div className={modalTitle == "Got an invite code?" ? "set-invited-code" : "none"}>
            <div className="title-tips">Enter the invitation code</div>
            <input className="input" value={invitCode} type="text" placeholder="enter invite code" onChange={onInputInviteCode} onKeyUp={onInputInviteCode} />
            <div className="com-btn" onClick={onSetInviteCode} style={{ margin: "5px auto" }}>Process</div>
            <div className="skip" onClick={onSkipInviteCode}>Skip</div>
          </div>
          <div className={modalTitle == "Please confirm the receiving address" ? "confirm-address" : "none"}>
            <div className="tips">{toAddress}</div>
            <div className="com-btn" style={{ margin: "5px auto" }} onClick={onBuySubmit}>OK</div>
          </div>
          <div className={modalTitle == "Disclaimer for CESS Genesis Nodes" ? "investment" : "none"}>
            <b>Compliance with Laws:</b><br />
            Users must comply with local laws and regulations. The CESS project (“CESS”) aims to operate in full compliance with applicable laws and regulations. However, CESS does not guarantee the procurement of any required licenses and/or approvals in any or every jurisdiction. Laws and regulations are subject to change, which may impact CESS ability to obtain necessary licenses in the future.
            <br /><br />
            <b>No Investment Advice:</b><br />
            CESS Genesis Nodes does not constitute investment, financial, or trading advice. It should not be relied upon for making investment decisions or considered a recommendation to buy CESS tokens.
            <br /><br />
            <b>Not a Security Offering:</b><br />
            CESS Genesis Nodes is not a financial service offering and should not be interpreted as an offer to sell or a solicitation to buy any security or financial instrument.
            <br /><br />
            <b>No Representations or Warranties:</b><br />
            No warranties or representations are made regarding the accuracy, reliability, or completeness of the information in this document. CESS shall not be liable for any loss or damage arising from reliance on this document.
            <br /><br />
            <b>Third-Party Data:</b><br />
            Information from third-party sources may be included in this document, which has not been independently verified by CESS.
            <br /><br />
            <b>Translations:</b><br />
            CESS Genesis Nodes may be translated from its original English version. The English version prevails in case of any discrepancies between translations.
            <br /><br />
            <b>Risk of Loss:</b><br />
            Investing in CESS tokens involves substantial risk, including the potential loss of principal. Investors should be aware of these risks and make informed decisions based on their own financial capability.
            <br /><br />
            <b>Regulatory Uncertainty:</b><br />
            The regulatory status of cryptographic tokens is uncertain and subject to change. This may impact your ability to use or trade CESS tokens.
            <br /><br />
            <b>Professional Advice:</b><br />
            The tax characterization of the CESS Tokens is uncertain. The purchaser shall seek his own tax advice in connection with the acquisition, storage, transfer, and use of the CESS Tokens, which may result in adverse tax consequences to the purchaser, including, without limitation, withholding taxes, transfer taxes, value-added taxes, income taxes and similar taxes, levies, duties or other charges and tax reporting requirements.
            <br /><br />
            <b>Forward-Looking Statements:</b><br />
            This document contains forward-looking statements based on current expectations. Actual results may differ materially due to various risks and uncertainties.
            <br /><br />
            Blockchain technologies and cryptographic tokens such as the CESS Tokens are relatively new and dynamic technology. In addition to the risks included above, there are other risks associated with your purchase, holding, and use of the CESS Tokens, including those that CESS cannot anticipate. Such risks may further appear as unanticipated variations or combinations of the risks discussed above.
          </div>
          <div className={modalTitle == "Invited History" ? "invited-history" : "none"}>
            <div className="tips">Invitation Code</div>
            <div className="mini-box">
              <span className="txt" onClick={() => onCopy(userInfo?.code)}>{userInfo?.code}</span>
              <span className="btn" onClick={onCopyInvitationLink}>Copy the invitation link</span>
            </div>
            <div className="total">Rewards：{rewards} CESS</div>
            <div className="con-table">
              <div className="table">
                <div className="tb-header">
                  <span className="td td1">Events</span>
                  <span className="td td2">Accounts</span>
                  <span className="td td3">Rewards($CESS)</span>
                  <span className="td td4">Date (UTC-0)</span>
                </div>
                <div className="tb-body">
                  {
                    invitedList.map((item, i) => {
                      return (
                        <div className="tr" key={i}>
                          <span className="td td1">{item["event"]}</span>
                          <span className="td td2" onClick={() => onCopy(item.account)} title="copy">{item["accountStr"]}</span>
                          <span className="td td3">{item["reward"]}</span>
                          <span className="td td4">{item["date"]}</span>
                        </div>
                      )
                    })
                  }
                </div>
                <div className={invitedList.length > 0 ? "none" : "no-record"}>No record</div>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
      {
        account && account.address ? <div id="myaddr" data-addr={account.address}></div> : ""
      }
    </div>
  );
};

export default App;
